<div class="content">

	<div class="hero-header overlap-top" [ngStyle]="{'background-image': isMobile ? 'url(/assets/images/home/rowan-heuvel-U6t80TWJ1DM-unsplash.jpg)' : 'url(/assets/images/home/rowan-heuvel-U6t80TWJ1DM-unsplash@2x.jpg)'}">
		<div class="container px-0 text-center h-100 d-flex flex-column justify-content-center">
			<h1 class="">Discover Excursions Worldwide</h1>

			<!-- <markdown class="text-gray" ngPreserveWhitespaces [innerHTML]="test"></markdown> -->
			<!-- <md-editor name="description" 
				[height]="'auto'" 
				[(ngModel)]="test" 
				[mode]="'preview'"
				[options]="options"
				>
				</md-editor> -->

			<div class="search-wrapper p-3">
				<ascedia-tab-group-controller
					[tabList]="tabListSearch"
					(emitter)="getChildSectionActive($event)"
					className="horiz justify-content-center search-tabs font-family-accent"
					#tabsSearch
					>
				</ascedia-tab-group-controller>


				<div class="search-bar">

					<div class="tab-group-content-inner" [ngClass]="{'active': 0 == sectionActive}">
						<div class=" d-md-flex align-items-center">
							<!-- <div class="text-small" *ngIf="cruiseLines$ | async as cruiseLines;">{{cruiseLines | json}}</div> -->
							<select 
								[(ngModel)]="cruiseLineId"
								[ngModelOptions]="{standalone: true}"
								class="form-control mb-2 mb-md-0 mr-md-2  m-md-0 w-md-33"
								(change)="getCruiseLineShipNames()"
								>
								<option value="" >Your Cruise Line</option>
								<ng-template #noShipNames>
									<option value="" >loading cruise lines</option>
								</ng-template>
								<ng-container *ngIf="cruiseLines$ | async as cruiseLines; else noShipNames">
									<option [value]="cruiseLine.cruiseLineId" *ngFor="let cruiseLine of cruiseLines">{{cruiseLine.cruiseLineName}}</option>
								</ng-container>
							</select>
							<select 
								[(ngModel)]="cruiseLineShipName"
								[ngModelOptions]="{standalone: true}"
								class="form-control mb-2 mb-md-0 mr-md-2  m-md-0 w-md-33"
								[disabled]="cruiseLineId == ''"
								(change)="getCruiseLineShipSailDates()"
								>
								<option value="" >Ship Name</option>
								<ng-template #noShipNames>
									<option value="" >loading ship names</option>
								</ng-template>
								<ng-container *ngIf="cruiseLineShipNames$ | async as cruiseLineShipNames; else noShipNames">
									<option [value]="cruiseLineShipName" *ngFor="let cruiseLineShipName of cruiseLineShipNames">{{cruiseLineShipName}}</option>
								</ng-container>
							</select>

							<select 
								[(ngModel)]="codeToCruiseId"
								[ngModelOptions]="{standalone: true}"
								class="form-control mb-2 mb-md-0 mr-md-2  m-md-0 w-md-33"
								[disabled]="cruiseLineShipName == ''"
								>
								<option value="" >Departure Date</option>
								<ng-template #noSailDates>
									<option value="" >loading dates</option>
								</ng-template>
								<ng-container *ngIf="cruiseLineShipSailDates$ | async as cruiseLineShipSailDates; else noSailDates">
									<option [value]="cruiseLineShipSailDate.codeToCruiseId" *ngFor="let cruiseLineShipSailDate of cruiseLineShipSailDates">{{cruiseLineShipSailDate.sailDate | date: 'MMM d, y'}} &ndash; {{cruiseLineShipSailDate.nights}} nights</option>
								</ng-container>
							</select>

							<button class="btn btn-primary btn-circle-icon text-light"
								(click)="gotoItinerary()"
								[disabled]="codeToCruiseId == ''">
								<fa-icon [icon]="['fas', 'search']"></fa-icon>
							</button>
						</div>
					</div>

					<div class="tab-group-content-inner" [ngClass]="{'active': 1 == sectionActive}">
						<div class="d-flex align-items-center search-inline">
							<fa-icon [icon]="['fas', 'search']" class="text-primary"></fa-icon>
							<input type="search" 
								class="form-control mx-2" 
								name="search"
								#search
								[(ngModel)]="searchModel" 
								[ngModelOptions]="{standalone: true}"
								(ngModelChange)="onChangeSearch($event)"
								autocomplete="off"
								placeholder="Search for Cities or Ports..."
								>
							<!-- <div class="btn btn-primary pill text-light"
								(click)="goToSearchPage()">
								<span>Search</span>
							</div> -->
						</div>
						<!-- (ngModelChange)="onChangeSearch($event)" -->

						<div class="search-results text-primary text-left mt-2" *ngIf="searchModel?.length > 1">
							<!-- FoundDestinations.len: {{foundDestinations?.length}} -->
							<ng-container *ngIf="foundDestinations?.length > 0">
								<div class="font-weight-bold mb-2">Suggestions</div>
								<a class="item" 
									*ngFor="let dest of foundDestinations"
									[routerLink]="['/destinations/' + dest.region.slug + '/' + dest.slug]" routerLinkActive="router-link-active" >{{dest.name}}</a>
							</ng-container>
							
							<ng-container *ngIf="!foundDestinations">
								No results for that search.
							</ng-container>
							
						</div>
						
					</div>
					
				</div>
			</div>
		</div>
	</div>

	

	<div class="container content-inner">

		<div class="bg-primary drop-shadow rounded-hidden text-white overlap-bottom mb-5 info-bar " >
			<div class="title-wrapper text-white mr-md-3">
				<div class="title" >Travel Worry Free With Compass Tours</div>
				<div class="subTitle"><a [routerLink]="['/support/how-it-works']" >See How We Help</a></div>
			</div>

			<ng-template #noInfoBoxes1>
				<div class="my-3">No InfoBoxes1 found.</div>
			</ng-template>
	
			<ng-container *ngIf="infoBoxes1$ | async as infoBoxes1; else noInfoBoxes1">
				<ascedia-info-box-accordion
					[infoBoxes]="infoBoxes1"
					class="w-md-66"
					className=" lines-mobile-only info-worry-free"
					textColor="#ffffff"
					lineColor="rgba(255,255,255,.5)"
					></ascedia-info-box-accordion>
			</ng-container>
		
		</div>

		<ng-template #noSliderListFeatured>
			<!-- <div class="my-3">No Featured lists found.</div> -->
		</ng-template>

		<ng-container *ngIf="sliderListFeatured$ | async as sliderListFeatured; else noSliderListFeatured">
			<ng-container *ngFor="let list of sliderListFeatured">
				<ascedia-swiper-card-image className="mb-5"
					[sliderList]="list.items"
					[hasFavorites]="false"
					[breakpoints]="breakpoints"
					[text]="list.title"
					className="overflow-visible"
					(toggleFavorite)="toggleFavorite($event)"
					>
				</ascedia-swiper-card-image>
			</ng-container>
		</ng-container>
		


	</div>

	<div class="container-fluid gradient-top py-5">

		<div class="container">
			<div class="font-family-accent text-center mb-4">
				<h5 class="text-green-pacific font-weight-bold">Excursions in 65+ Destinations</h5>
				<h2 class="text-headline font-weight-bold">Explore Destinations Worldwide</h2>
			</div>
			

			 <!--<div class="button-slider-wrapper mb-3" 
				*ngIf="regions$ | async as regions; else noRegions"
				#buttonSliderWrapper>
				<div class="button-slider" 
					#buttonSlider
					[ngStyle]="{'left.px': buttonSliderX}">
					<div *ngFor="let region of regions; let i = index;"
						#region
						(click)="loadButtonSlider(i);"
						class="mr-2 btn btn-outline-primary button-slider-btn-region pill no-break" 
						[ngClass]="{'active': i == regionActive}"
						>
						{{region.name}}
					</div>
				</div>
				<div class="button-slider-btn-prev" 
					(click)="buttonSlide(1)"
					*ngIf="showButtonSliderPrev">
					<div class="btn btn-quaternary btn-circle-icon text-light">
						<fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
					</div>
				</div>
				<div class="button-slider-btn-next"
					(click)="buttonSlide(-1)"
					*ngIf="showButtonSliderNext">
					<div class="btn btn-quaternary btn-circle-icon text-light">
						<fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
					</div>
				</div>
			</div>
			<ng-template #noRegions>
				<div class="my-3">No regions found.</div>
			</ng-template> -->


			<ng-container *ngIf="imageGrid$ | async as imageGrid;">
				<ng-container *ngFor="let grid of imageGrid">
					<ascedia-image-grid
						[imageGrid]="grid"
						[showTitles]="true"
						className="mb-3 rounded-corners"
						></ascedia-image-grid>
				</ng-container>
			</ng-container>

			<!-- <div class="bred text-small" *ngIf="imageGrid$ | async as imageGrid;">{{imageGrid | json}}</div> -->

			<div class="text-center mb-4">
				<a class="btn btn-primary pill font-weight-bold" [routerLink]="['/destinations']"  >View More Destinations</a>
			</div>

		</div>

	</div>




	<div class="container-fluid bg-green-haze py-5 mb-5 ">

		<div class="container">
			<div class="d-md-flex mb-3">
				<div class="image overlap-bottom w-md-50 order-2 mb-3">
					<img src="/assets/images/home/travelers-beach-collage.png" alt="people" class="w-100" *ngIf="isMobile" />
					<img src="/assets/images/home/travelers-beach-collage@2x.png" alt="people" class="w-100" *ngIf="!isMobile" />
				</div>
				<div class="info text-green-dark w-md-50 order-1 mt-5 pr-md-3">
					<h2 class="font-family-accent font-weight-bold mb-3">What's it Like to Book Through Compass Tours?</h2>
					<div class="mb-4">Easy! Book on our website, call us to book or book through your travel professional.</div>
					<a class="btn btn-tertiary pill" [routerLink]="['/support/how-it-works']" >See How it Works</a>
				</div>
				
			</div>

			<ng-template #noInfoBoxes2>
				<div class="my-3">No InfoBoxes2 found.</div>
			</ng-template>
	
			<ng-container *ngIf="infoBoxes2$ | async as infoBoxes2; else noInfoBoxes2">
				<ascedia-info-box-accordion
					[infoBoxes]="infoBoxes2"
					className="centered info-whats-it-like"
					textColor="#095940"
					lineColor="#095940"
					></ascedia-info-box-accordion>
			</ng-container>

		</div>

	</div>
	
	

	<div class="container content-inner">

		<ng-template #noSliderListPromo>
			<!-- <div class="my-3">No Promo lists found.</div> -->
		</ng-template>

		<ng-container *ngIf="sliderListPromo$ | async as sliderListPromo; else noSliderListPromo">
			<ng-container *ngFor="let list of sliderListPromo">
				<ascedia-swiper-card-image className="mb-5"
					[sliderList]="list.items"
					[hasFavorites]="false"
					[breakpoints]="breakpoints"
					[text]="list.title"
					className="overflow-visible"
					(toggleFavorite)="toggleFavorite($event)"
					>
				</ascedia-swiper-card-image>
			</ng-container>
		</ng-container>


	</div>

	<app-safety></app-safety>

</div>
